import { INSIGHTS_SERP_ROUTE } from '../../routes';
import { MegaMenuMiddleBlock, MegaMenuRightBlock } from '../../types';
import { MegaMenuBlockTypes, MegaMenuLeftBlockItemsTypes } from './types';

export const LOGGED_IN_ITEMS: ExpandedNavigationItem[] = [
  {
    title: 'home',
    url: '/home',
    className: 'home-link',
    type: 'link',
  },
  {
    title: 'explore',
    url: '/discover',
    type: 'MegaMenu',
  },
  {
    title: 'analytics',
    url: '/analytics/dashboard',
    managerUrl: '/analytics/dashboard',
    avoidManagerUrlWithoutSub: true,
    type: 'link',
  },
];

export const PROFILE_LINKS = [
  {
    title: 'header.myAccount',
    url: '/my-account/',
  },
  {
    title: 'header.myMembership',
    url: '/my-account/membership-area/',
  },
  {
    title: 'header.myWatchlist',
    url: '/home/#my-watchlist',
  },
];

export type SubNavigationItem = {
  title: string;
  description: string;
  url: string;
};

export type ExpandedNavigationItem = {
  title: string;
  url: string;
  type: string;
  subItems?: SubNavigationItem[];
  className?: string;
  managerUrl?: string;
  avoidManagerUrlWithoutSub?: boolean;
};

export const LEFT_MEGA_MENU = {
  item_type: MegaMenuBlockTypes.LeftBlock,
  title: 'learnerProfiles',
  external_link: '/discover/search',
  text_external_link: 'exploreAll',
  type_left_block: MegaMenuLeftBlockItemsTypes.ListItem,
};

export const ESG_COURSE_ITEM = {
  title: 'esgCertificate',
  sub_title: 'esgCertificateDescription',
  link: '/courses/esg-foundations',
  image_url: '/headers-images/MegaMenuIcons/coursesIcon.svg',
};

export const MIDDLE_MEGA_MENU = {
  item_type: MegaMenuBlockTypes.MiddleBlock,
  title: 'exploreOurLearningPathways',
  items: [
    {
      title: 'shortCourses',
      sub_title: 'shortCoursesDescription',
      link: '/discover/pathways',
      image_url: '/headers-images/MegaMenuIcons/pathwaysIcon.svg',
    },
    {
      title: 'certificates',
      sub_title: 'certificatesDescription',
      link: '/courses',
      image_url: '/headers-images/MegaMenuIcons/coursesIcon.svg',
    },
    {
      title: 'videosModules',
      sub_title: 'videoModulesDescription',
      link: '/discover/videos',
      image_url: '/headers-images/MegaMenuIcons/videosIcon.svg',
    },
    {
      title: 'glossary',
      sub_title: 'glossaryDescription',
      link: '/discover/glossary',
      image_url: '/headers-images/MegaMenuIcons/glossaryIcon.svg',
    },
    {
      title: 'insights',
      sub_title: 'insightsDescription',
      link: '/discover/insights',
      image_url: '/headers-images/MegaMenuIcons/insightsIcon.svg',
    },
  ],
};

export const RIGHT_MEGA_MENU = {
  item_type: MegaMenuBlockTypes.RightBlock,
  title: 'trendingCourses',
};

export const formatMegaMenuItem = (megaMenu, t, hasNews, baseCategoriesList, twoLatestVideos) => {
  const leftBlock = {
    ...LEFT_MEGA_MENU,
    title: t(`header.${LEFT_MEGA_MENU.title}`),
    text_external_link: t(`header.${LEFT_MEGA_MENU.text_external_link}`),
    items: baseCategoriesList?.map((item) => ({
      title: item?.title,
      link: `/discover/${item?.slug}`,
    })),
  };

  const middleBLock: MegaMenuMiddleBlock = {
    ...MIDDLE_MEGA_MENU,
    title: t(`header.${MIDDLE_MEGA_MENU.title}`),
    clickable_items: MIDDLE_MEGA_MENU.items
      .filter(
        (item) =>
          (item?.link === INSIGHTS_SERP_ROUTE && hasNews) || item.link !== INSIGHTS_SERP_ROUTE,
      )
      .map((item) => ({
        ...item,
        title: t(`header.${item.title}`),
        sub_title: t(`header.${item.sub_title}`),
      })),
  };

  const rightBlock: MegaMenuRightBlock = {
    ...RIGHT_MEGA_MENU,
    title: t(`header.${RIGHT_MEGA_MENU.title}`),
    items: twoLatestVideos?.length
      ? twoLatestVideos.map((item) => ({
          title: item?.title,
          description: item?.description,
          image_url: item?.preview_url,
          link: `/videos/${item?.video_url}`,
          play_icon: true,
        }))
      : [],
  };

  return {
    ...megaMenu,
    title: t(`header.${megaMenu.title}`),
    blocks: [leftBlock, middleBLock, rightBlock],
  };
};
